module.exports = __webpack_public_path__ + "img/fi-toasts-400x263.6c88ad8e.jpg";